import { FILE_SIZE } from '@shared/constants/fileSize';
import { FILE_TYPES } from '@shared/constants/fileTypes';
import FileValidator from '@shared/validators/FileValidator';

const MAX_FILE_SIZE = 5 * FILE_SIZE.MB;

const DeDuplicatedMetricDocumentValidator = {
  fileSchema: FileValidator.createFileSchema(
    [FILE_TYPES.CSV, FILE_TYPES.XLSX, FILE_TYPES.XLS],
    MAX_FILE_SIZE
  )
};

export default DeDuplicatedMetricDocumentValidator;
